type TabletType = {
  active?: boolean;
  className?: string;
};
const Tablet = ({ active, className = '' }: TabletType) => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    xmlns="http://www.w3.org/2000/svg"
    fill={`${active ? 'white' : '#393939'} `}
    aria-hidden="true"
    focusable="false"
    className={className}
  >
    <path
      d="M22.748 3.625C23.6249 3.62516 24.3432 4.32462 24.374 5.19434L24.375 5.25293V18.748C24.3748 19.6249 23.6752 20.3432 22.8057 20.374L22.748 20.375H2.75195C1.87515 20.3748 1.1568 19.6752 1.12598 18.8057L1.125 18.748V5.25293C1.125 4.37581 1.82464 3.6568 2.69434 3.62598L2.75195 3.625H22.748ZM2.75195 4.875C2.55745 4.87516 2.39451 5.02808 2.37695 5.21875L2.375 5.25293V18.748C2.37515 18.9424 2.52754 19.1052 2.71777 19.123L2.75195 19.125H22.748C22.9424 19.1248 23.1052 18.9725 23.123 18.7822L23.125 18.748V5.25293C23.125 5.05826 22.9726 4.89476 22.7822 4.87695L22.748 4.875H2.75195ZM14.75 16.375C15.0952 16.375 15.375 16.6549 15.375 17C15.375 17.3314 15.117 17.6029 14.791 17.624L14.75 17.625H10.75C10.4048 17.625 10.125 17.3452 10.125 17C10.125 16.6687 10.383 16.3971 10.709 16.376L10.75 16.375H14.75Z"
      fill="black"
    />
  </svg>
);
export default Tablet;
